const createDataCyAttribute = (content, prefix = '', suffix = '') => {
    if (content) {
        return (prefix + content + suffix).replace(/[_,.]/g, '-').toLowerCase();
    } else {
        return 'error';
    }
};

export default createDataCyAttribute;